import { atom } from "recoil"

export const AtomCurrentBadge2Name = atom({
    key:'ATOMCURBADGENAME2',
    default:''
})
  